module.exports = __webpack_public_path__ + "static/img/11.1d35ea61.png";